import React, { useState, useEffect } from 'react'
import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js"
import api from '../api'
import Input from "@/components/Input"
import Button from './Button'
import Loader from "./Loader"
import { CheckCircle, ChevronRight, CreditCard, ShoppingBag, X } from 'react-feather'
import { Link } from 'react-router-dom'

export default function CheckoutForm({onCancel,onSuccess,onPayment,showAddressForm,setShowAddressForm}) {
  const [succeeded, setSucceeded] = useState(false)
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [clientSecret, setClientSecret] = useState('')
  const [orderDetails, setOrderDetails] = useState({})
  const [address, setAddress] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState("");
  const stripe = useStripe()
  const elements = useElements()

  useEffect(() => {
    (async () => {
      const resp = await api.proceedCheckout()
      // console.log("checkout",resp)
       setOrderDetails(resp.finalOrder)

       const addressResp = await api.fetchUserAddress()
       // console.log("user address",addressResp);
       setAddress(addressResp.address);
      // if (resp.status !== "error") {
      //   // setClientSecret(resp.clientSecret)
      //   setOrderDetails(resp.finalOrder)
      // }
    })();
  }, [])

  const isCod = orderDetails?.products?.every((item => item.product?.cod == true ))
  // console.log("cod",isCod)

   const paymentMethods = [
              { id: "card", title: "Credit/Debit Card" },
              { id: "upi", title: "UPI" },
            ];

            if(isCod){
              paymentMethods.push( { id: "cod", title:"COD"})
            }


  const cardStyle = {
    style: {
      base: {
        fontSmoothing: "antialiased",
        fontSize: "16px",
        color: "#27272a",
        "::placeholder": {
          color: "gray"
        },
        "::-ms-clear": {
          border: "2px solid gray"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    }
  }
  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty)
    setError(event.error ? event.error.message : "")
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   setProcessing(true)
  //   // const payload = await stripe.confirmCardPayment(clientSecret, {
  //   //   payment_method: {
  //   //     card: elements.getElement(CardElement)
  //   //   }
  //   // })
  //   if (payload.error) {
  //     setError(`Payment failed ${payload.error.message}`);
  //     setProcessing(false)
  //   } else {
  //     setError(null)
  //     setProcessing(false)
  //     setSucceeded(true)
  //     onSuccess()
  //   }
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(selectedAddress === null){
      alert("Please select an address");
      return;
    }
    setProcessing(true);
    try {
        await onSuccess(address[selectedAddress],selectedPayment,orderDetails.couponAmount,orderDetails.delCharge); 
        setSucceeded(true);
        setError(null);
    } catch (err) {
        setError("Could not place order: " + err.message);
    } finally {
        setProcessing(false);
    }
};

const handlePayment = async (e) => {
e.preventDefault();
if(selectedAddress === null){
      alert("Please select an address");
      return;
    }
    setProcessing(true);
    try {
      await onPayment(address[selectedAddress],selectedPayment,orderDetails.couponAmount,orderDetails.delCharge);
        setSucceeded(true);
        setError(null);
    } catch (err) {
        setError("Could not place order: " + err.message);
    } finally {
        setProcessing(false);
    }
}

const handleAddressSubmit = (e) => {
  e.preventDefault();
  const form = new FormData(e.target);
  const newAddress = {
    name: form.get("name"),
    phone: form.get("phone"),
    area: form.get("area"),
    city: form.get("city"),
    state: form.get("state"),
    country: form.get("country"),
    pincode: form.get("pincode"),
  };

  setAddress(prev => [...prev, newAddress]);
  setSelectedAddress(address.length);
  setShowAddressForm(false);
};

const handleDeleteAddress = (index) => {
  setAddress(prev => prev.filter((_, i) => i !== index));
};


  // if (succeeded) 
  //   {
  //   return (
  //     <div className='flex flex-col items-center'>
  //       <CheckCircle className='w-20 h-20 text-green-400' />
  //       <p className='text-lg font-light my-4'>Order Placed Successfully</p>
  //       <Link to="/orders">
  //         <Button link>
  //           <span>Go to Orders</span>
  //           <ChevronRight className='ml-2' />
  //         </Button>
  //       </Link>
	// 			<Button secondary onClick={onCancel}>Close</Button>
  //     </div>
  //   )
  // }

  return (
    <div>
      <section className='mb-6'>
        {orderDetails?.amount && 
          <div className='flex justify-between text-lg mt-2'>
            <h4 className='text-lg mb-2'>Final Order</h4>
            <span className='font-bold text-xl'>₹{orderDetails?.amount.toFixed(2)}</span>
          </div>
        }
        {orderDetails?.products?.length ?
          <ul>
            {orderDetails.products.map(p => (
              <CheckoutItem 
                key={p.product._id}
                title={p.product.iName} 
                price={p.product.tranRate} 
                quantity={p.quantity} 
                type={p.product.type}
                style={p.product.style}
              />
            ))}
          </ul>
          : <Loader color="bg-gray-600" />
        }
         {orderDetails?.amount && 
          <div className='flex justify-between mt-1'>
            <h4 className='text-lg mb-2'>Delivery Charges</h4>
            <span className='text-lg font-light'>₹{orderDetails.delCharge}</span>
          </div>
        }
         {orderDetails?.amount && orderDetails?.couponAmount ? 
          <div className='flex justify-between mt-1'>
            <h4 className='text-lg mb-2'>Discount</h4>
            <span className='text-lg font-light'>- ₹{orderDetails.couponAmount}</span>
          </div>
          : <></>
        }
      </section>

    {address?.length > 0 && (
  <div className="mb-4">
    <h4 className="font-semibold mb-2">Shipping Addresses</h4>

    {address.map((addr, index) => (
      <div 
        key={index} 
        className="bg-white p-3 rounded border border-gray-300 mb-3"
      >
        <input
                  type="radio"
                  name="addresscheck"
                  value={index}
                  checked={selectedAddress===index}
                  onChange={() => setSelectedAddress(index)}
                  className="mt-1"
                />
        <p className="font-bold">{addr.name}</p>
        <p>{addr.phone}</p>
        <p>{addr.area}, {addr.city}</p>
        <p>{addr.state}, {addr.country} - {addr.pincode}</p>

        <Button 
          type="button" 
          secondary 
          className="mt-2"
          onClick={() => handleDeleteAddress(index)}
        >
          Delete
        </Button>
      </div>
    ))}
  </div>
)}

       {showAddressForm ? (
						<form 
							className="flex flex-col gap-2 min-w-xs max-w-lg m-4"
							onSubmit={handleAddressSubmit}
						>
							<Input name="name" type="text" placeholder="Name" required />
              <Input name="phone" type="text" placeholder="Phone" required />
              <Input name="area" type="text" placeholder="Area" required />
              <Input name="city" type="text" placeholder="City" required />
              <Input name="state" type="text" placeholder="State" required />
              <Input name="country" type="text" placeholder="Country" required />
              <Input name="pincode" type="text" placeholder="Pincode" required />
							<div className="text-right mt-4">
								<Button secondary onClick={() => setShowAddressForm(false)}>Cancel</Button>
								<Button type="submit">Add</Button>
							</div>
						  </form>
					  ) : (
							 <Button type="button" className="w-full" secondary onClick={() => setShowAddressForm(true)}>Add Address</Button>
						)}

      <form onSubmit={handleSubmit}>
        <CardElement options={cardStyle} onChange={handleChange} />
        {/* Show any error that happens when processing the payment */}
        {error && (
          <div className="text-red-400 mt-2" role="alert">
            {error}
          </div>
        )}
         
         <h3 className="text-lg font-medium mt-10 mb-4">Select Payment Method</h3>
          <div className="space-y-2">
            {paymentMethods.map((method) => (
              <label key={method.id} className="flex items-center gap-2">
                <input
                  type="radio"
                  name="payment"
                  value={method.id}
                  checked={selectedPayment === method.id}
                  onChange={() => setSelectedPayment(method.id)}
                />
                {method.title}
              </label>
            ))}
            </div>
           
 {selectedPayment == "cod"?
        <Button className="w-full mt-6" disabled={processing || succeeded}>
          {processing
            ? <Loader/>
            : <>
              <ShoppingBag className='mr-2 opacity-70' />
              {succeeded 
              ?<span>Order Placed</span>
              :<span>Place Order</span>
              }
            </>
          }
        </Button>
         :<Button type="button" className="w-full mt-6" onClick={handlePayment} disabled={processing||succeeded}>
          {processing 
            ? <Loader/>
            : <>
              <CreditCard className='mr-2 opacity-70' /> 
              <span>Make Payment</span>
            </>
          }
        </Button>
}
				<Button type="button" className="w-full" secondary onClick={onCancel}>Cancel</Button>
      </form>
    </div>
  );
}

function CheckoutItem({title, price, quantity, type, style}) {
  return (
    <li className='flex justify-between'>
      <p>{title} ({type}) ({style})</p>
      <div className='flex justify-between items-center'>
        {quantity > 1 &&
          <span className='inline-flex items-center text-gray-400 mr-5'>
            <X className='' />
            {quantity}
          </span>
        }
        <span className='text-lg font-light'>₹{quantity*price}</span>
      </div>
    </li>
  )
}